import axios from "@/axios";
import Util from "../../../../util/util";
import moment from "moment";

export const namespaced = true;

const defaultData = {
  id: 0,
  financeName: null,
  financeUnitOffice: null,
  financeOrganizationId: null,
  financeSignature: {
    signatureId: 0,
    type: "TEXT",
    text: null,
    fontFamily: null,
    edit: null,
    view: null,
  },
  financeSignatureId: 5,
  financeDateSigned: null,
  organizations: [],
};

const resetData = {
  type: "TEXT",
  text: null,
  fontFamily: null,
  edit: null,
  view: null,
};

const IMAGE_EXP = /data:image\/[a-z]+;base64,/;

export const state = {
  financialRepresentative: Object.assign({}, defaultData),
  helper: { countryId: 0, buySell: "" },
  status: false,
  financialRepresentativeErrors: [],
};

export const getters = {
  financialRepresentative: (state) => state.financialRepresentative,
  financialRepresentativeStatus: (state) => state.status,
  financialRepresentativeHelper: (state) => state.helper,
  financialRepresentativeErrors: (state) => state.financialRepresentativeErrors
};

export const mutations = {
  SET_FINANCE_API: (state, response) => {
    state.financialRepresentative = Object.assign({}, state.financialRepresentative, response.data, { financeSignature: response.data.financeSignature ? response.data.financeSignature : defaultData.financeSignature });

    if (state.financialRepresentative.financeSignature.edit && !state.financialRepresentative.financeSignature.edit.match(IMAGE_EXP)) {
      state.financialRepresentative.financeSignature.edit = window.atob(state.financialRepresentative.financeSignature.edit)
    }

    if (state.financialRepresentative.financeSignature.view && !state.financialRepresentative.financeSignature.view.match(IMAGE_EXP)) {
      state.financialRepresentative.financeSignature.view = window.atob(state.financialRepresentative.financeSignature.view)
    }
  },
  SET_FINANCE_SIG: (state, response) => {
    var financeSig = Object.assign({}, response.data.financeSignature ? response.data.financeSignature : defaultData.financeSignature);
    financeSig.edit = window.atob(financeSig.edit);
    financeSig.view = window.atob(financeSig.view);
    state.financialRepresentative.financeSignature = financeSig;
  },
  SET_FINANCE_DATA: (state, data) => {
    state.financialRepresentative = Object.assign({}, state.financialRepresentative, data)
  },

  SET_STATUS: (state, value) => (state.status = value),

  SET_HELPER: (state, value) => (state.helper = value),
  CLEAR_DATA: (state) => (state.financialRepresentative = defaultData),
  SET_ERRORS: (state, data) => (state.financialRepresentativeErrors = data),
  CLEAR_ERRORS: (state) => (state.financialRepresentativeErrors = [])
};

export const actions = {
  clearData({ commit }) {
    commit("CLEAR_DATA");
  },

  async getFinancialRepresentativeStatus({ commit }, id) {
    if (id == 0) {
      commit("SET_STATUS", false);
    }
    else {
      return await axios.get(`/api/financesignatures/status/${id}`)
        .then(({ data }) => {
          if (data && data.length === 0) {
            commit("SET_STATUS", true);
            commit("CLEAR_ERRORS");
          }
          else {
            commit("SET_STATUS", false);
            commit("SET_ERRORS", data);
          }
        });
    }
  },

  async getFinancialRepresentativeHelper({ commit }, id) {
    if (id == 0) {
      commit("SET_HELPER", { countryId: 0, buySell: "" });
    }
    else {
      return await axios.get("/api/signatures/helper/" + id)
        .then(({ data }) => {
          commit("SET_HELPER", data);
        });
    }
  },

  async getFinancialRepresentative({ commit }, orderId) {
    try {
      commit("SET_FINANCE_API", await axios.get(`/api/financesignatures/${orderId}`));
    }
    catch (error) {
      console.log("ERROR LOADING FINANCE INFORMATION: ", error); //not handelled
    }
  },

  async getFinancialRepresentativeSigOnly({ commit }, orderId) {
    try {
      commit("SET_FINANCE_SIG", await axios.get(`/api/financesignatures/${orderId}`));
    }
    catch (error) {
      console.log("ERROR LOADING FINANCE INFORMATION: ", error); //not handelled
    }
  },

  getCacSignature({ dispatch }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/signatures/certificatename")
        .then(function (response) {
          const cacSignature = "data:image/jpg;base64," + response.data;
          dispatch("setSignature", cacSignature);
          return resolve();
        })
        .catch(function (error) {
          return reject(`There was an error getting the CAC signature... ${error.response.data}`);
        });
    });
  },

  setSignature({ commit, state }, signature) {
    let date = null;

    // Don't auto-set date for UPLOAD type — backend handles signature dates
    if (!Util.isNullOrEmpty(signature) && signature.type !== "UPLOAD") {
      date = Util.convertToDateTime(moment.utc().format("MM-DD-y HH:mm:ss"));
    }

    commit("SET_FINANCE_DATA", { financeSignature: Object.assign({}, state.financialRepresentative.financeSignature, signature), financeDateSigned: date });
  },

  async getOrganizations({ commit, state }, params) {
    try {
      let response = []
      response = await axios.get("/api/organizations/countrycode/US");

      let organizationId = (response && response.data) ? state.financialRepresentative.financeOrganizationId : null

      commit("SET_FINANCE_DATA", { organizations: response.data, financeOrganizationId: organizationId });

      let found = response.data.find(item => item.id === state.financialRepresentative.financeOrganizationId);

      if (params.preOrderDetailStatus && params.agreementInformationStatus && !found) {
        commit("SET_FINANCE_DATA", { financeOrganizationId: null });
      }
    }
    catch (error) {
      commit("SET_FINANCE_DATA", { financeOrganizationId: null, organizations: [] });
    }
  },

  async saveFinancialRepresentative({ commit, state, dispatch }, data) {
    //return new Promise((resolve, reject) => {
      let finance = Object.assign({}, state.financialRepresentative, {
        financeSignature: (!state.financialRepresentative.financeSignature.view) ? null :
          {
            ...state.financialRepresentative.financeSignature,
            edit: (state.financialRepresentative.financeSignature.edit) ? window.btoa(state.financialRepresentative.financeSignature.edit) : "",
            view: (state.financialRepresentative.financeSignature.view) ? window.btoa(state.financialRepresentative.financeSignature.view) : "",
          },
        financeDateSigned: Util.convertToDateTime(state.financialRepresentative.financeDateSigned)
      });

      try {
        await axios.post("/api/financesignatures", finance, { config: { showToast: false } })
        //await dispatch("getFinancialRepresentative", data.orderId);
      } catch(error) {
        return reject(`There was an error saving Finance to the server...  ${error.response.data}`);
      }
  },
};
